import { autoId } from "~/utils/auto-id";

const TILL_ID_KEY = "web-till-id";
const DEVICE_ID_KEY = "web-device-id";

export function getWebTillId(): string | null {
  return localStorage.getItem(TILL_ID_KEY);
}

export function setWebTillId(tillId: string) {
  localStorage.setItem(TILL_ID_KEY, tillId);
}

export function getWebDeviceId(): string {
  const existingId = localStorage.getItem(DEVICE_ID_KEY);
  if (existingId) {
    return existingId;
  }

  const newId = autoId();
  localStorage.setItem(DEVICE_ID_KEY, newId);
  return newId;
}

/**
 * Check if the current environment is a web browser instead of React Native WebView.
 *
 * @returns True if the current environment is web, false otherwise.
 */
export function isWebBrowser(): boolean {
  return typeof window.ReactNativeWebView === "undefined";
}
